module.exports = "https://r.nearpod.com/assets/media/image/front_of_classroom-a1119fe0d554fb17f6d5482d07d79c23.svg";